/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface RechercheApprenantValidationCeMasseSearch
 */
export interface RechercheApprenantValidationCeMasseSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    masculin?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    codeClasse?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    classe?: TextSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RechercheApprenantValidationCeMasseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the RechercheApprenantValidationCeMasseSearch interface.
 */
export function instanceOfRechercheApprenantValidationCeMasseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RechercheApprenantValidationCeMasseSearchFromJSON(json: any): RechercheApprenantValidationCeMasseSearch {
    return RechercheApprenantValidationCeMasseSearchFromJSONTyped(json, false);
}

export function RechercheApprenantValidationCeMasseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): RechercheApprenantValidationCeMasseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'masculin': !exists(json, 'masculin') ? undefined : TextSearchFromJSON(json['masculin']),
        'codeClasse': !exists(json, 'codeClasse') ? undefined : TextSearchFromJSON(json['codeClasse']),
        'classe': !exists(json, 'classe') ? undefined : TextSearchFromJSON(json['classe']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function RechercheApprenantValidationCeMasseSearchToJSON(value?: RechercheApprenantValidationCeMasseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'masculin': TextSearchToJSON(value.masculin),
        'codeClasse': TextSearchToJSON(value.codeClasse),
        'classe': TextSearchToJSON(value.classe),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

